import React from 'react';

export function splitOrderItems(items = []) {
    const regular = [];
    const extraClient = [];
    for (const it of items) {
        // Once a client extra is served it's just part of the order — show it as a
        // normal line, no "extra" highlight. Only pending extras stay highlighted.
        if (it.is_extra && it.source === 'client' && it.extra_state !== 'served') extraClient.push(it);
        else regular.push(it);
    }
    return { regular, extraClient };
}

function isItemServed(item) {
    if (item.is_extra && item.source === 'client') return item.extra_state === 'served';
    return item.serve_state === 'served';
}

function ItemLine({ item, showPrice, variant }) {
    const isKitchen = variant === 'kitchen';
    const served = isItemServed(item);
    const text = `${item.quantity}× ${item.product_name}${item.variant_name ? ` · ${item.variant_name}` : ''}`;
    const servedTag = served ? <span style={{ color: 'var(--text-faint)' }}> (SERVITĂ)</span> : null;
    const servedStyle = served ? { opacity: 0.55, textDecoration: 'line-through' } : null;
    if (isKitchen) {
        return (
            <li style={servedStyle || undefined}>
                • {text}{servedTag}
                {item.notes && <em style={{ color: 'var(--amber)' }}> ({item.notes})</em>}
            </li>
        );
    }
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: variant === 'compact' ? '0.9rem' : '0.92rem', ...(servedStyle || {}) }}>
            <span>{text}{servedTag}</span>
            {showPrice && <span style={{ flexShrink: 0 }}>{(item.price * item.quantity).toFixed(2)} RON</span>}
        </div>
    );
}

export function OrderItemsList({ items = [], showPrices = false, variant = 'default', extraLabel = 'Extra de la client' }) {
    const { regular, extraClient } = splitOrderItems(items);
    const isKitchen = variant === 'kitchen';

    if (isKitchen) {
        return (
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 0.6rem 0', fontSize: '0.9rem', color: '#e5e5e5' }}>
                {regular.map((it, i) => <ItemLine key={`r-${i}`} item={it} variant={variant} />)}
                {extraClient.length > 0 && (
                    <>
                        <li className="order-items-extra-label" style={{ listStyle: 'none', marginTop: 8, marginBottom: 4 }}>{extraLabel}</li>
                        {extraClient.map((it, i) => (
                            <li key={`e-${i}`} className="order-item-extra">
                                • {it.quantity}× {it.product_name}
                                {it.variant_name ? <span style={{ opacity: 0.85 }}> · {it.variant_name}</span> : null}
                                {it.notes && <em style={{ color: 'var(--amber)' }}> ({it.notes})</em>}
                            </li>
                        ))}
                    </>
                )}
            </ul>
        );
    }

    return (
        <div className="order-items-list" data-testid="order-items-list">
            {regular.map((it, i) => (
                <div key={`r-${i}`} className="order-item-regular">
                    <ItemLine item={it} showPrice={showPrices} variant={variant} />
                </div>
            ))}
            {extraClient.length > 0 && (
                <div className="order-items-extra-block">
                    <div className="order-items-extra-label">{extraLabel}</div>
                    {extraClient.map((it, i) => (
                        <div key={`e-${i}`} className="order-item-extra">
                            <ItemLine item={it} showPrice={showPrices} variant={variant} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
